import { useState, useEffect } from "react";

const useRefDimensions = (wrapperRef: React.RefObject<HTMLDivElement>) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const handleChangeWidthAndHeight = () => {
    setWidth(wrapperRef.current?.clientWidth ?? 0);
    setHeight(wrapperRef.current?.clientHeight ?? 0);
  };

  useEffect(handleChangeWidthAndHeight, [wrapperRef.current]);

  useEffect(() => {
    window.addEventListener("resize", handleChangeWidthAndHeight, false);
    return () => window.removeEventListener("resize", handleChangeWidthAndHeight);
  }, [wrapperRef]);

  return { width, height };
};

export default useRefDimensions;
